<template>
  <div>
    <v-toolbar dense flat>
      <v-toolbar-title>
        <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
      </v-toolbar-title>
    </v-toolbar>

    <v-container fluid class="justify-center">
      <d-header label="New Program Page" />
      <create-header label="Program page" :goBackTo="goback" :disabled="!canCreate" :oncreate="create" />

      <v-row>
        <v-col cols="12">
          <a-card>
            <elwrapper label="Internal title" midtext>
              <f-text v-model="internalTitle" />
              <div class="caption grey--text mt-1">Used in the database list and when picking a page for a quote.</div>
            </elwrapper>
            <elwrapper label="Program title" midtext>
              <f-textarea v-model="title" rows="3" />
              <div class="caption grey--text mt-1">
                Shown on the printed page. Optional: first line = smaller intro, following lines = main title
              </div>
            </elwrapper>
            <elwrapper label="Type" midtext>
              <f-dropdown :items="typeItems" :value="type" hideClear @input="onTypeChange" />
            </elwrapper>
            <elwrapper label="Content" midtext>
              <ProgramPageContentEditor :title="title" :type="type" :value="content" @input="(val) => (content = val)" />
            </elwrapper>
          </a-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  ProgramPageContentEditor,
  PAGE_TYPES,
  DEFAULT_PAGE_TYPE,
  defaultContentForType,
  normalizePageContent,
} from "@/modules/program_pages";

export default {
  components: {
    ProgramPageContentEditor,
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: "Database",
          to: { name: "database" },
        },
        {
          text: "Program pages",
          to: { name: "database_view", params: { view: "program_pages", sub: "ALL" } },
        },
        {
          text: "New",
        },
      ],
      goback: { name: "database_view", params: { view: "program_pages", sub: "ALL" } },
      internalTitle: "",
      title: "",
      type: DEFAULT_PAGE_TYPE,
      content: defaultContentForType(),
    };
  },
  computed: {
    typeItems() {
      return PAGE_TYPES.map((item) => ({ label: item.label, value: item.value }));
    },
    canCreate() {
      return String(this.internalTitle || "").trim().length > 0;
    },
  },
  methods: {
    onTypeChange(nextType) {
      if (this.type === nextType) return;
      this.type = nextType;
    },
    create() {
      return this.$store
        .dispatch("ProgramPageStore/addProgramPage", {
          internal_title: this.internalTitle,
          title: this.title,
          type: this.type,
          content: normalizePageContent(this.type, this.content),
        })
        .then((id) => {
          this.$root.$success("Created Program page: " + this.internalTitle);
          this.$router.push({
            name: "program_page_info",
            params: { id },
          });
        })
        .catch((err) => this.$root.$error(err));
    },
  },
};
</script>
